import { useContent } from "@/context/ContentContext";
import { fileUrl } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { ScrollText, ShieldCheck, Gavel } from "lucide-react";
import RichText, { isHtml } from "@/components/RichText";

const DEFAULT_HERO = "https://static.prod-images.emergentagent.com/jobs/69bc8a3c-ed6c-4b85-a9a2-ec966ad0ef18/images/b51224e52b5ba39d64dc003b2dec0b7112c6bb96e711a5c19bae09e13086b773.jpeg";

export default function Status() {
  const { t } = useContent();
  const body = t("status_body");

  return (
    <div>
      <PageHeader label="Podstawa prawna" title="Status prawny i statut" subtitle={t("status_intro")} bgImage={t("status_hero_image") ? fileUrl(t("status_hero_image")) : DEFAULT_HERO} />
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div className="grid gap-4 sm:grid-cols-3">
          {[
            { icon: ShieldCheck, label: "Osobowość prawna", val: "Izba Gospodarcza" },
            { icon: ScrollText, label: "Podstawa", val: "Ustawa z 1989 r." },
            { icon: Gavel, label: "KRS", val: "0000128771" },
          ].map((c, i) => (
            <div key={i} className="rounded-2xl border border-border bg-card p-6" data-testid={`status-card-${i}`}>
              <c.icon className="mb-3 h-6 w-6 text-ztk-blue" />
              <p className="label-mono text-[10px] text-muted-foreground">{c.label}</p>
              <p className="mt-1 font-display font-semibold text-ztk-navy dark:text-white">{c.val}</p>
            </div>
          ))}
        </div>
        <article className="mt-12 text-base leading-relaxed text-slate-700 dark:text-slate-300" data-testid="status-body">
          {isHtml(body) ? (
            <RichText html={body} />
          ) : (
            <div className="space-y-5">
              {body.split("\n\n").map((p, i) => (<p key={i}>{p}</p>))}
            </div>
          )}
        </article>
      </div>
    </div>
  );
}
